// https://forkify-api.herokuapp.com/v2

// cb389937-1ee7-437a-9578-0da0cc18ae21, a8d5496b-3d85-4d0f-b074-a2ef3a08387a

// https://forkify-api.herokuapp.com/api/v2/recipes/5ed6604591c37cdc054bc886

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const KEY = 'a8d5496b-3d85-4d0f-b074-a2ef3a08387a';
export const TIMEOUT_SECONDS = 10;
export const WRONG_RECIPE_MESSAGE =
  'This recipe was not found. Please try another one or check the recipe ID.';
export const WRONG_QUERY_MESSAGE =
  'Nothing was found. Please try another query.';
export const RESULTS_PER_PAGE = 10;
export const NO_BOOKMARKS_MESSAGE =
  'No bookmarks yet. Find a nice recipe and bookmark it :)';
export const MODAL_CLOSE_SECONDS = 2.5;
export const UPLOAD_SUCCESS_MESSAGE = 'Recipe was successfully uploaded';
